/* Sales POC page helpers (number formatting lives in growthos-shared/gxFormat). */
import React from 'react'
import { Box, Tooltip } from '@mui/material'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import { GX_COLORS, GxPill } from '../growthos-shared/GrowthOsUi'

export const PERIODS = [
  { value: 'mtd', label: 'MTD' }, { value: 'last_month', label: 'Last Month' },
  { value: 'last_3m', label: 'Last 3M' }, { value: 'last_6m', label: 'Last 6M' },
  { value: 'ytd', label: 'YTD' }, { value: 'all', label: 'All time' }, { value: 'custom', label: 'Custom' },
]

// Explicit per-section window tag ("ProShip: Sep 1 – Sep 28", "Trailing 12 months").
export function ScopeTag({ label, title }) {
  return (
    <Tooltip title={title || ''}>
      <Box component="span"><GxPill color={GX_COLORS.indigo} icon={<CalendarTodayIcon sx={{ fontSize: 12 }} />}>{label}</GxPill></Box>
    </Tooltip>
  )
}
